import clsx from 'clsx';

export function FlagUsIcon({ className, ...props }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      className={clsx(className)}
      {...props}
    >
      <path d="M20 0H0V20H20V0Z" fill="#F0F0F0" />
      <path d="M20 2.5H0V5H20V2.5Z" fill="#D80027" />
      <path d="M20 7.5H0V10H20V7.5Z" fill="#D80027" />
      <path d="M20 12.5H0V15H20V12.5Z" fill="#D80027" />
      <path d="M20 17.5H0V20H20V17.5Z" fill="#D80027" />
      <path d="M10 0H0V10.7691H10V0Z" fill="#2E52B2" />
      <path
        d="M2.01336 4.50462L1.79484 5.17693H1.08789L1.65988 5.59232L1.44137 6.26466L2.01336 5.84927L2.58512 6.26466L2.36656 5.59232L2.93855 5.17693H2.23164L2.01336 4.50462Z"
        fill="#F0F0F0"
      />
      <path
        d="M2.23164 7.6033L2.01336 6.931L1.79484 7.6033H1.08789L1.65988 8.0187L1.44137 8.691L2.01336 8.27565L2.58512 8.691L2.36656 8.0187L2.93855 7.6033H2.23164Z"
        fill="#F0F0F0"
      />
      <path
        d="M2.01336 2.07821L1.79484 2.75055H1.08789L1.65988 3.1659L1.44137 3.83825L2.01336 3.42286L2.58512 3.83825L2.36656 3.1659L2.93855 2.75055H2.23164L2.01336 2.07821Z"
        fill="#F0F0F0"
      />
      <path
        d="M4.99969 4.50462L4.78117 5.17693H4.07422L4.64621 5.59232L4.4277 6.26466L4.99969 5.84927L5.57145 6.26466L5.35289 5.59232L5.92492 5.17693H5.21797L4.99969 4.50462Z"
        fill="#F0F0F0"
      />
      <path
        d="M5.21797 7.6033L4.99969 6.931L4.78117 7.6033H4.07422L4.64621 8.0187L4.4277 8.691L4.99969 8.27565L5.57145 8.691L5.35289 8.0187L5.92492 7.6033H5.21797Z"
        fill="#F0F0F0"
      />
      <path
        d="M8.20621 7.6033L7.98797 6.931L7.76941 7.6033H7.0625L7.63449 8.0187L7.41594 8.691L7.98797 8.27565L8.55969 8.691L8.34117 8.0187L8.91316 7.6033H8.20621Z"
        fill="#F0F0F0"
      />
      <path
        d="M7.98797 4.50462L7.76941 5.17693H7.0625L7.63449 5.59232L7.41594 6.26466L7.98797 5.84927L8.55969 6.26466L8.34117 5.59232L8.91316 5.17693H8.20621L7.98797 4.50462Z"
        fill="#F0F0F0"
      />
      <path
        d="M4.99969 2.07821L4.78117 2.75055H4.07422L4.64621 3.1659L4.4277 3.83825L4.99969 3.42286L5.57145 3.83825L5.35289 3.1659L5.92492 2.75055H5.21797L4.99969 2.07821Z"
        fill="#F0F0F0"
      />
      <path
        d="M7.98797 2.07821L7.76941 2.75055H7.0625L7.63449 3.1659L7.41594 3.83825L7.98797 3.42286L8.55969 3.83825L8.34117 3.1659L8.91316 2.75055H8.20621L7.98797 2.07821Z"
        fill="#F0F0F0"
      />
    </svg>
  );
}
